import React, { Component } from "react";
import logo from "../logo-circle_512x512.png";
import "./Navigation.css";

export class Navigation extends Component {
    render() {
        return (
            <nav id="menu" className="navbar navbar-expand-lg navbar-light bg-light navbar-default">
                <div className="container">
                    <a className="navbar-brand" href="#page-top">
                        <img src={logo} className="App-logo" alt="logo" width="70px" height="70px"/>
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarNavAltMarkup" aria-controls="navbarNavDropdown" aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div
                        className="collapse navbar-collapse"
                        id="navbarNavAltMarkup"
                    >
                        <ul className="navbar-nav">
                            <li className="nav-item active">
                                <a href="#about" className="nav-link page-scroll">
                                    About
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#services" className="nav-link page-scroll">
                                    Services
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#portfolio" className="nav-link page-scroll">
                                    Gallery
                                </a>
                            </li>
                            {/*<li className="nav-item">*/}
                            {/*    <a href="#team" className="nav-link page-scroll">*/}
                            {/*        Team*/}
                            {/*    </a>*/}
                            {/*</li>*/}
                            <li className="nav-item">
                                <a href="#contact" className="nav-link page-scroll">
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Navigation;